"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionTypeEnum = void 0;
var SubscriptionTypeEnum;
(function (SubscriptionTypeEnum) {
    SubscriptionTypeEnum[SubscriptionTypeEnum["INITIAL_REQUEST"] = 0] = "INITIAL_REQUEST";
    SubscriptionTypeEnum[SubscriptionTypeEnum["RENEWAL_REQUEST"] = 1] = "RENEWAL_REQUEST";
})(SubscriptionTypeEnum || (exports.SubscriptionTypeEnum = SubscriptionTypeEnum = {}));
